import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

const thresholdTokens = [{ propertyPath: 'warning', tokenName: '--threshold-warning' }] satisfies Token[];

export const thresholdTokenMetadata: PaletteTokenMetadata = {
  componentName: 'threshold',
  tokens: thresholdTokens,
};

export const threshold = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['threshold'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(thresholdTokens, tokens, xcorTokens);
  }
  return {
    warning: '#DA7B07',
  };
};
